/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef, useContext } from "react";
import Layout from "components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Combobox,
  DatePicker,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import { useGetRoutes, useAutocompleteCIT } from "utils/apis/lookups.api";
import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { formatDate } from "date-fns";
import { PREV_5_DAY_DATE } from "utils/constant";
import { useCreateDeliveryOrder } from "utils/apis/deliveries.api";
import { Link } from "react-router-dom";
import SearchableDropdown from "components/searchableDropdown";
import { UserContext } from "utils/reducers/user";

const formSchema = z.object({
  cashCenterId: z.string().min(1, { message: "Destination is required." }),
  customerId: z.string().min(1, { message: "Billing Customer is required." }),
  customerName: z.string().min(1, { message: "Billing Customer is required." }),
  servicePointId: z.string().min(1, { message: "Source is required." }),
  requestedBy: z.string().min(1, { message: "Requested By is required." }),
  serviceDateTime: z.date({
    required_error: "Service date is required.",
  }),
  serviceType: z.string(),
  invoicingModel: z
    .string()
    .min(1, { message: "Invoicing Model is required." }),
  priority: z.string().min(1, { message: "Job Priority is required." }),
  jobNature: z.string().min(1, { message: "Job Nature is required." }),
  jobType: z.string().min(1, { message: "Job Type is required." }),
  shift: z.string().min(1, { message: "Shift is required." }),
  routeNo: z.string().optional(),
  remarks: z.string().optional(),
});

const jobPriorities = [
  { value: "1", name: "Critical" },
  { value: "2", name: "High" },
  { value: "3", name: "Normal" },
  { value: "4", name: "Low" },
];

const jobNatures = [
  {
    value: "Normal",
    name: "Normal",
  },
  {
    value: "Adhoc",
    name: "Adhoc",
  },
  {
    value: "Special Service",
    name: "Special Service",
  },
];

const jobTypes = [
  {
    value: "Cash Delivery",
    name: "Cash Delivery",
  },
];

const invoicingModels = [
  {
    value: "Fixed",
    name: "Fixed",
  },
  {
    value: "Dedicated",
    name: "Dedicated",
  },
  {
    value: "Service",
    name: "Service",
  },
];

export default function CreateDelivery() {
  const { CashCenterId } = useContext(UserContext);
  const [destinationLocation, setDestinationLocation] = useState<any>(null);
  const [requestedCurrencies, setRequestedCurrencies] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      cashCenterId: CashCenterId || "",
      customerId: "",
      servicePointId: "",
      customerName: "",
      serviceType: "Delivery",
      invoicingModel: "Service",
      priority: "2",
      jobNature: "Normal",
      shift: "morning",
      jobType: "Cash Delivery",
      routeNo: "",
      requestedBy: "",
      remarks: "",
      serviceDateTime: new Date(),
    },
  });

  const requestedCurrenciesList = useRef<any>([]);
  const currencyDenominationsList = useRef<any>([]);

  const { data: autocompleteResults, isFetching: isFetchingAutocomplete } =
    useAutocompleteCIT(searchTerm);
  const { data: inRouteTeams } = useGetRoutes();

  const {
    mutate: createDeliveryOrder,
    isSuccess: isOrderSuccess,
    isPending: isOrderPending,
    isError: isOrderError,
    reset: orderReset,
  } = useCreateDeliveryOrder();

  function onSubmit(values: z.infer<typeof formSchema>) {
    const destinationId = destinationLocation?.locationId || "";
    const destinationName = destinationLocation?.locationName || "";

    const requiredCash = requestedCurrencies.map((cc: any) => ({
      currency: cc.currency,
      declaredValue: cc.declaredValue,
      denominations: cc.requiredDenominations,
    }));
    const currentDate = new Date();

    const dateWithCurrentTime = new Date(values.serviceDateTime).setHours(
      currentDate.getHours(),
      currentDate.getMinutes(),
      currentDate.getSeconds(),
      currentDate.getMilliseconds(),
    );
    const requestDto = {
      ...values,
      serviceDateTime: formatDate(
        dateWithCurrentTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      ),
      destination: destinationName,
      destinationId,
      requiredCash,
    };
    createDeliveryOrder(requestDto);
  }

  const onDestinationLocationChanged = (value: string) => {
    const dsp: any = autocompleteResults?.find(
      (sp: any) => String(sp.servicePointId) === String(value),
    );
    if (dsp) {
      setDestinationLocation(dsp);
      form.setValue("customerId", dsp?.customerId);
      form.setValue("customerName", dsp?.customer);
    } else {
      setDestinationLocation(null);
    }
  };

  useEffect(() => {
    if (isOrderSuccess) {
      form.reset();
      orderReset();
      setDestinationLocation(null);
      setRequestedCurrencies([]);
      setSearchTerm("");
      requestedCurrenciesList.current = [];
      currencyDenominationsList.current = [];
    }
    if (isOrderError) {
      orderReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderSuccess, isOrderError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/deliveries">Deliveries</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Delivery Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <div className="flex mx-4 my-5 gap-3">
        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardTitle className="text-lg">Service Details</CardTitle>
            <CardDescription className="mt-3">
              <Form {...form}>
                <form
                  id="collection-form"
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="gap-4 grid grid-cols-2"
                >
                  <FormField
                    control={form.control}
                    name="servicePointId"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Destination Location</FormLabel>
                        <SearchableDropdown
                          placeholder="Search Destination Location"
                          value={field.value}
                          searchTerm={searchTerm}
                          onSearchChange={setSearchTerm}
                          data={
                            autocompleteResults?.map((item: any) => ({
                              value: item.servicePointId,
                              label: `${item.barcode || ""}-${item.locationId}`,
                            })) || []
                          }
                          loading={isFetchingAutocomplete}
                          onChange={(val) => {
                            field.onChange(val);
                            onDestinationLocationChanged(val);
                          }}
                        />

                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="customerName"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Billing Customer</FormLabel>
                        <FormControl>
                          <Input
                            type="text"
                            placeholder="Select Destination Location"
                            readOnly
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />

                  <FormField
                    control={form.control}
                    name="serviceDateTime"
                    render={({ field }) => (
                      <FormItem className="space-y-2">
                        <FormLabel>Service Date</FormLabel>
                        <DatePicker
                          {...field}
                          placeholder="Pick a date"
                          selectedDate={field.value}
                          onSelectDate={field.onChange}
                          disabled={(date) => date < PREV_5_DAY_DATE}
                        />
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormSelect
                    form={form}
                    data={invoicingModels}
                    name="invoicingModel"
                    label="Invoicing Model"
                    placeholder="Select Invoicing Model"
                  />
                  <FormSelect
                    form={form}
                    data={jobPriorities}
                    name="priority"
                    label="Job Priority"
                    placeholder="Select Job Priority"
                  />
                  <FormSelect
                    form={form}
                    data={jobTypes}
                    name="jobType"
                    label="Job Type"
                    placeholder="Select Job Type"
                  />
                  <FormSelect
                    form={form}
                    data={jobNatures}
                    name="jobNature"
                    label="Job Nature"
                    placeholder="Select Job Nature"
                  />

                  <FormCombobox
                    form={form}
                    data={inRouteTeams?.map((m: any) => ({
                      value: String(m.routeNo),
                      label: `${m.routeNo} (${m.description})`,
                    }))}
                    name="routeNo"
                    label="Route"
                    placeholder="Select Route"
                  />

                  <FormField
                    control={form.control}
                    name="requestedBy"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Requested By</FormLabel>
                        <FormControl>
                          <Input
                            type="text"
                            placeholder="Select Requested By"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>Remarks</FormLabel>
                        <FormControl>
                          <Textarea
                            placeholder="Write your remarks"
                            className="resize-none"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <div />
                  <Button
                    type="submit"
                    variant="secondary"
                    disabled={isOrderPending}
                    isLoading={isOrderPending}
                  >
                    Confirm
                  </Button>
                </form>
              </Form>
            </CardDescription>
          </CardContent>
        </Card>
        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardTitle className="text-lg">Request Review</CardTitle>
            <CardDescription className="mt-4">
              <h5 className="text-md font-bold">Delivery Site</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {destinationLocation?.locationId}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {destinationLocation?.locationName}
                  </div>
                </div>
                <div>
                  <label>Location Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {destinationLocation?.locationType}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {destinationLocation?.routeNo}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {destinationLocation?.siteLimit}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {destinationLocation?.serviceDays}
                  </div>
                </div>
              </div>
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
